import { render, staticRenderFns } from "./MobileAccordion.vue?vue&type=template&id=4fb20f6e&"
import script from "./MobileAccordion.vue?vue&type=script&lang=js&"
export * from "./MobileAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb20f6e')) {
      api.createRecord('4fb20f6e', component.options)
    } else {
      api.reload('4fb20f6e', component.options)
    }
    module.hot.accept("./MobileAccordion.vue?vue&type=template&id=4fb20f6e&", function () {
      api.rerender('4fb20f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/HomeVantage/Summaries/MobileAccordion.vue"
export default component.exports